import type { IsEqual } from 'type-fest';
import type { ActualEventMap } from './create-emitter';
import { createEmitter } from './create-emitter';

/**
 * Как добавить что-то в интерфейс:
 * В нужном месте объявить подобную конструкцию
 * ```declare module '@/shared/lib/emitter/global' {
 *   // eslint-disable-next-line ts/consistent-type-definitions
 *   interface EmitterEvents {
 *     eventName: eventPayload;
 *   }
 * }```
 * eventName - ключ event
 * eventPayload - тип передаваемых данных
 */
// eslint-disable-next-line ts/consistent-type-definitions
export interface EmitterEvents extends Record<string, unknown> {
  // Важно!!! Тут объявлять нельзя
}

/**
 * Как добавить что-то в интерфейс:
 * В нужном месте объявить подобную конструкцию
 * ```declare module '@/shared/lib/emitter/global' {
 *   // eslint-disable-next-line ts/consistent-type-definitions
 *   interface EmitterEventJobs {
 *     typeName: eventPayload;
 *   }
 * }```
 * typeName - ключ type у событий `job`
 * eventPayload - тип передаваемых данных
 */
// eslint-disable-next-line ts/consistent-type-definitions
export interface EmitterEventJobs extends Record<string, unknown> {
  // Важно!!! Тут объявлять нельзя
}

type ClearExtend<T extends Record<string, unknown>> = {
  [Key in keyof T as IsEqual<Key, string> extends true ? never : Key]: T[Key];
};
type ClearEvents = ClearExtend<EmitterEvents>;
type ClearJobs = ClearExtend<EmitterEventJobs>;

type ActualEvents = ClearEvents & {
  job: {
    [Key in keyof ClearJobs]: {
      event: 'job';
      type: Key;
      data: ClearJobs[Key];
    }
  }[keyof ClearJobs];
};

// Global emitter for any purpose
export const globalEmitter = createEmitter<ActualEvents>({ ttl: 100000 });

export type GlobalEmitterEvent<Key extends keyof ActualEventMap<ActualEvents>> = ActualEventMap<ActualEvents>[Key];

export type GlobalEmitterJob<Key extends ActualEventMap<ActualEvents>['job']['type']> = Extract<GlobalEmitterEvent<'job'>, { type: Key }>;
